// extracted by mini-css-extract-plugin
export default {"mainLayout":"YFpKLtko"};